window.addEventListener('DOMContentLoaded',()=> {
  const addButtons = document.querySelectorAll('.productDetail__form-variantUrl .Button');
  addButtons.forEach(addButton => {
    addButton.addEventListener('click',()=> {
      const variantId = addButton.dataset.variantid;
      const inventory = addButton.dataset.inventory;
      if(Number(inventory) != 0 ) {
        console.log(variantId);      
        addCart(Number(variantId));
      }
    });
  });

  async function addCart(variantId) {
    //カート追加
    let formData = {
     'items': [{
      'id': variantId,
      'quantity': 1
      }]
    };
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    window.location.href = "/cart"; 
  }
});
